import { gql } from '@apollo/client';

export const CHAT_MUTATION = gql`
	mutation Chat($input: ChatInput!) {
		chat(input: $input) {
			text
			crewMembers {
				id
				fullName
				driverCard
				isActive
				phone
				currentHomeBase {
					city {
						name
					}
				}
				currentRun {
					id
					name
				}
				currentEmploymentType {
					id
					employmentType
					effectiveTimestamp
				}
				driverLicenseExpiresAt
				drugTestExpiresAt
				medicalCheckExpiresAt
			}
		}
	}
`;
